import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subject, switchMap, debounceTime } from 'rxjs';
import { ClientService } from '../../../core/api/client.service';
import { ClientList } from '../../../core/models/client.model';
import { PaginatedResponse } from '../../../core/models/api.model';
import { PaginationComponent, PageChange } from '../../../shared/components/pagination/pagination.component';
import { ClientCardComponent } from '../client-card/client-card.component';

@Component({
  selector: 'app-client-list',
  standalone: true,
  imports: [
    CommonModule, FormsModule, RouterModule, MatIconModule, MatButtonModule,
    MatInputModule, MatFormFieldModule, MatListModule, MatProgressSpinnerModule,
    PaginationComponent, ClientCardComponent,
  ],
  templateUrl: './client-list.component.html',
  styleUrl: './client-list.component.scss',
})
export class ClientListComponent implements OnInit {
  loading = true;
  clients: ClientList[] = [];
  searchQuery = '';
  currentPage = 1;
  pageSize = 20;
  totalItems = 0;
  totalPages = 1;
  private searchSubject = new Subject<{ query: string; page: number; pageSize: number }>();

  constructor(private clientService: ClientService) {}

  ngOnInit(): void {
    this.searchSubject.pipe(
      debounceTime(300),
      switchMap(({ query, page, pageSize }) => {
        this.loading = true;
        const params = new HttpParams()
          .set('page', String(page))
          .set('page_size', String(pageSize));
        if (query.length >= 2) {
          return this.clientService.search(query, params);
        }
        return this.clientService.list(params);
      }),
    ).subscribe({
      next: (res: PaginatedResponse<ClientList>) => {
        this.clients = res.results;
        this.currentPage = res.page;
        this.totalPages = res.pages;
        this.totalItems = res.count;
        this.loading = false;
      },
      error: () => { this.loading = false; },
    });

    this.loadPage(1);
  }

  onSearch(query: string): void {
    this.searchSubject.next({ query, page: 1, pageSize: this.pageSize });
  }

  onPageChange(change: PageChange): void {
    this.loadPage(change.page, change.pageSize);
  }

  private loadPage(page: number, pageSize?: number): void {
    if (pageSize && pageSize !== this.pageSize) {
      this.pageSize = pageSize;
    }
    this.searchSubject.next({ query: this.searchQuery, page, pageSize: this.pageSize });
  }
}
